// @ts-nocheck
import RootStore from "./RootStore";
import { action, observable } from "mobx";
import { restServices } from "../../cuba/services";
import { getCubaREST } from "@cuba-platform/react";
import { PersonProfile } from "../pages/MyTeam/MyTeamCard";


class PersonProfileStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable personProfile:PersonProfile;

  @observable imageUrl:string
  @observable imageUrlWithoutBlob:string
  @action.bound loadPersonProfile = (id:string) => {
    return restServices.employeeService
      .personProfile(id)
      .then(value => {
        this.personProfile = value;
        if (this.personProfile && this.personProfile.imageId) {
          this.imageUrlWithoutBlob = this.personProfile.imageId
          return getCubaREST()!
            .getFile(this.personProfile.imageId)
            .then((value: Blob) => {
              return this.imageUrl = URL.createObjectURL(value)
            });
        }
        return null
      })
      .catch((err) => {
        console.log(err)
      });
  };
}

export default PersonProfileStore;
